"use client";

import { useEffect } from "react";

import { client } from "@/api_client/client.gen";

import {
  antiForgeryMiddleware,
  recaptchaMiddleware,
} from "./clientMiddlewares";

let antiForgeryInterceptorRegistered = false;
let recaptchaInterceptorRegistered = false;
let middlewareBaseUrl: string | undefined;
let configuredBaseUrl: string | undefined;

export function registerClientMiddlewareNoHook(
  baseUrl?: string,
  registerRecaptchaMiddleware = false,
) {
  middlewareBaseUrl = baseUrl;

  if (!antiForgeryInterceptorRegistered) {
    client.interceptors.request.use((req) =>
      antiForgeryMiddleware(req, middlewareBaseUrl),
    );
    antiForgeryInterceptorRegistered = true;
  }

  if (registerRecaptchaMiddleware && !recaptchaInterceptorRegistered) {
    client.interceptors.request.use(recaptchaMiddleware);
    recaptchaInterceptorRegistered = true;
  }

  if (baseUrl && configuredBaseUrl !== baseUrl) {
    client.setConfig({ baseUrl, credentials: "include" });
    configuredBaseUrl = baseUrl;
  }
}

type RegisterClientMiddlewareProps = {
  baseUrl?: string;
  registerRecaptchaMiddleware?: boolean;
};

export function RegisterClientMiddleware({
  baseUrl,
  registerRecaptchaMiddleware = false,
}: RegisterClientMiddlewareProps) {
  useEffect(() => {
    registerClientMiddlewareNoHook(baseUrl, registerRecaptchaMiddleware);
  }, [baseUrl, registerRecaptchaMiddleware]);

  return null;
}
